import { useState, useEffect } from "react";
import { fetchAccreditationData } from "../utils/fetchAccreditationData";

export function useAccreditationCount(userId, selectedFolder) {
  const [accreditationChangeCount, setAccreditationChangeCount] = useState(0);

  useEffect(() => {
    async function initializeAccreditationCount() {
      if (!userId || !selectedFolder) {
        setAccreditationChangeCount(0);
        return;
      }
      try {
        const files = await fetchAccreditationData(
          userId,
          selectedFolder.folderId
        );
        setAccreditationChangeCount(files.length);
      } catch (e) {
        setAccreditationChangeCount(0);
      }
    }
    initializeAccreditationCount();
  }, [userId, selectedFolder]);

  return [accreditationChangeCount, setAccreditationChangeCount];
}
